import type { ReportShellChip } from '../Components/ReportShell'
import { REPORT_LIST_FILTERS, type ReportFilterState } from '../Contracts/Report'
import { defaultPeriod, formatPeriodLabel } from './reportPeriod'
import { REPORT_OPTION_SOURCES } from './reportSources'

export interface ReportChip {
    key: string
    label: string
    value: string
    /** Стан фільтрів без цієї умови */
    remove: (state: ReportFilterState) => ReportFilterState
}

const SOURCE_LABELS = { requests: 'З заявками', standalone: 'Без заявок' } as const

/**
 * Чіпи активних умов звіту (як у списках): період — лише коли він не за замовчуванням
 * (поточний місяць — це не «фільтр»), «×» повертає поточний місяць; списки — через кому.
 */
export const buildReportChips = (state: ReportFilterState, defaultPeriodLabel: string): ReportChip[] => {
    const chips: ReportChip[] = []
    const periodLabel = formatPeriodLabel(state.period)
    if (periodLabel !== defaultPeriodLabel) {
        chips.push({
            key: 'period',
            label: 'Період',
            value: periodLabel,
            remove: (s) => ({ ...s, period: defaultPeriod() }),
        })
    }
    if (state.source !== 'all') {
        chips.push({
            key: 'source',
            label: 'Задачі',
            value: SOURCE_LABELS[state.source],
            remove: (s) => ({ ...s, source: 'all' }),
        })
    }
    if (state.isHired !== 'all') {
        chips.push({
            key: 'isHired',
            label: 'Найманий транспорт',
            value: state.isHired === 'true' ? 'Так' : 'Ні',
            remove: (s) => ({ ...s, isHired: 'all' }),
        })
    }
    REPORT_LIST_FILTERS.forEach((name) => {
        const options = state.lists[name]
        if (options.length === 0) return
        chips.push({
            key: name,
            label: REPORT_OPTION_SOURCES[name].label,
            value: options.map((option) => option.label).join(', '),
            remove: (s) => ({ ...s, lists: { ...s.lists, [name]: [] } }),
        })
    })
    return chips
}

/** Чіпи фільтрів задач для ReportShell: «×» передає стан без умови в onChange */
export const taskReportShellChips = (
    state: ReportFilterState,
    onChange: (state: ReportFilterState) => void
): ReportShellChip[] =>
    buildReportChips(state, formatPeriodLabel(defaultPeriod())).map(({ key, label, value, remove }) => ({
        key,
        label,
        value,
        onRemove: () => onChange(remove(state)),
    }))
